import { useLocation } from "react-router-dom"

import { GlobalStyle, Container } from "../../common/styles/global-style"
import { urlsPages } from "../../common/urls/urls-pages"
import { ButtonPrimary } from "../../common"
import { Description, IconWrap, Title, Wrapper } from "./style"
import { MdOutlineEmail } from "react-icons/md"


export const VerifyEmail = () => {
  const location = useLocation()
  const email = (location.state as { email?: string } | null)?.email

  const description = email
    ? `Acabamos de enviar um link de verificação para ${email}.`
    : `Acabamos de enviar um link de verificação para o e-mail informado no cadastro.`

  return (
    <>
      <GlobalStyle />
      <Container>
        <Wrapper>
          <IconWrap>
            <MdOutlineEmail size={48} />
          </IconWrap>
          <Title>Verifique seu e-mail</Title>
          <Description>{description}</Description>
          <ButtonPrimary 
            width="35%"           
            margintop="24px"
            marginbottom="30px"
            goToPage={urlsPages.signin}
          >
            Ir para login →
          </ButtonPrimary>
        </Wrapper>
      </Container>
    </>
  )
}
